import React from 'react';
import Auxilary from '../../../hoc/auxilary'
import Button from '../../UI/Button/Button';

const orderSummary = (props) =>
{
    const ingredientSummary = Object.keys(props.ingredients).map(igKeys =>
        {
            return  (<li key = {igKeys}>
                    <span style = {{textTransform: 'capitalize'}}>
                        {igKeys}: {props.ingredients[igKeys]}</span>
                </li>);
        }
    );
    
    
    return (
        <Auxilary>
            <h3>Your Order</h3>
            <p>With the finest ingredients, your burger:</p>
            <ul>
                {ingredientSummary}
            </ul>
            <p><strong>Total Price: ${props.priceTotal.toFixed(2)}</strong></p>
            <p>Continue to Checkout?</p>
            <Button btnType = "Danger" clicked = {props.purchaseCanceled}>CANCEL</Button>
            <Button btnType = "Success" clicked = {props.purchasedContinued}>CONTINUE</Button>
        </Auxilary>
    );
};

export default orderSummary;


// WEBPACK FOOTER //
// ./src/components/Burger/OrderSummary/OrderSummary.js